import { apiSlice } from '../../api/apiSlice';
import { InUseSimsResponse } from './inUseSimsApiSliceTypes';
import { DashboardParams } from '../dashboardTypes';
import { serializeQueryParams } from '../index';

const inUseSimsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getInUseSims: builder.query<InUseSimsResponse, DashboardParams>({
            query: (params) => ({
                url: `/dashboard/in-use-sims?${serializeQueryParams(params)}`,
                method: 'GET',
                headers: {
                    'Accept-Language': params.acceptLanguage ?? 'en',
                },
            }),
        }),
    }),
    overrideExisting: true,
});

export const { useGetInUseSimsQuery, useLazyGetInUseSimsQuery } =
    inUseSimsApiSlice;
